import { getViewEnum } from "src/common/helpers";

export enum BetTypeEnum {
	Single = 1,
	Multiple,
	System,
	Chain,
	StraightForecast = 40,
	ReverseForecast = 41,
	CombinationForecast = 42,
	StraightTricast = 43,
	CombinationTricast = 44,
	// Used only for internal bet builder place-bet via create_bets.
	InternalBetBuilder = 51,
}

export const BetTypeViewEnum = getViewEnum(BetTypeEnum);
